interface SpacerProps {
  size?: "sm" | "md" | "lg" | "xl";
}

export default function Spacer({ size = "md" }: SpacerProps) {
  const sizes = {
    sm: "h-[15px]",
    md: "h-[30px]",
    lg: "h-[50px]",
    xl: "h-[75px]",
  };

  return <div className={sizes[size]}></div>;
}
